
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import OrderedCheckBox from "@/components/utils/PopulateForms/components/OrderedCheckBox.vue";
import { nameInfoType, otherPartyInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { enfrcOtherPartyDataInfoType, form26InformationDataInfoType } from '@/types/Application/AgreementEnforcement/PDF';
import { enforceAgreementOrOrderSurveyDataInfoType } from '@/types/Application/AgreementEnforcement';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
        OrderedCheckBox        
    }
})

export default class Form26Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;   
    
    otherPartyInfo: enfrcOtherPartyDataInfoType[] = [];
    additionalOtherParties: enfrcOtherPartyDataInfoType[] = [];
    firstOtherParty = {} as enfrcOtherPartyDataInfoType;
    yourInfo = {} as yourInformationInfoDataInfoType;
    form26Info = {} as form26InformationDataInfoType;
    
    existingFileNumber = ''   
    

    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){
               
        this.otherPartyInfo=this.getOtherPartyInfo()        
        this.firstOtherParty = this.otherPartyInfo[0];
        if (this.otherPartyInfo?.length > 1) {
            this.otherPartyInfo.splice(0,1)
            this.additionalOtherParties = this.otherPartyInfo;
        }       
        
        this.yourInfo = this.getYourInfo();
        this.form26Info = this.getForm26Info();
        this.existingFileNumber = getLocationInfo(this.result.filingLocationSurvey);        
    } 
    

    
    public getYourInfo(){           

        if(this.result?.yourInformationSurvey){
            return getYourInformationResults(this.result?.yourInformationSurvey); 
        } 
        else
            return {} as yourInformationInfoDataInfoType
    }

    public getOtherPartyInfo(){

        let OpInformation: enfrcOtherPartyDataInfoType[] = [];        

        if (this.result.otherPartyCommonSurvey?.length > 0){
            OpInformation = [];
            const otherPartyData: otherPartyInfoType[] =  this.result.otherPartyCommonSurvey;
           
            for(const party of otherPartyData){ 
                const otherParty = {} as enfrcOtherPartyDataInfoType;               

                if (party.knowDob == 'y' &&  party.dob)
                    otherParty.dob = party.dob

                if (party.name)
                    otherParty.name = party.name;
                
                if (party.address)
                    otherParty.address = party.address;
                
                if (party.contactInfo)
                    otherParty.contactInfo = party.contactInfo;

                if (party.lawyer)
                    otherParty.lawyer = party.lawyer
                                
                OpInformation.push(otherParty)
            }
        } 

        return OpInformation
    }  
    
    public getForm26Info() {        

        const form26Information = {} as form26InformationDataInfoType;
        form26Information.agreementList = [];
        form26Information.agreementDate = '';        
        
        if (this.result?.enfrcQuestionnaireSurvey?.includes('writtenAgreementOrder') && this.result?.enforceAgreementOrOrderSurvey) { 

            const enfrcAgrmntOrdr: enforceAgreementOrOrderSurveyDataInfoType = JSON.parse(JSON.stringify(this.result.enforceAgreementOrOrderSurvey));

            const form26Conditions = (enfrcAgrmntOrdr.enforceOrder == "n") && (enfrcAgrmntOrdr.filedOrder == 'n') && (enfrcAgrmntOrdr.existingType == "writtenAgreement")

            form26Information.agreementDate = (form26Conditions)?Vue.filter('beautify-date')(enfrcAgrmntOrdr.existingDate):'';
            form26Information.agreementList = (form26Conditions)?enfrcAgrmntOrdr.agreementType:[];
            form26Information.filed = form26Conditions;
        }
        //console.log(form26Information)
        if(this.result?.enfrcQuestionnaireSurvey?.includes('parentingCoordinatorDetermination')){
            const detData  = this.result?.enforceChangeSetAsideDeterminationSurvey
            if(detData?.filedOrder == "n" && detData?.appointedDetermination?.selected == "writtenAgreement" && detData?.filedAgreement == "n"){
                form26Information.agreementList.push("section15");
                if(form26Information.agreementDate == ''){
                    form26Information.filed = true;
                    form26Information.agreementDate = Vue.filter('beautify-date-blank')(detData?.appointedDetermination?.writtenAgreementDate);
                }            
            }
       
        }

        return form26Information;
    }
 
}

